<template>
  <div class="diaryCheck">
    <div class="diaryCheckContents">
      <div class="diaryCheckText">
        <v-text-field
          v-model="comment" 
          placeholder="한 줄 평으로 도전을 응원하세요."
          hide-details="true"
          maxlength="100"
        >
        </v-text-field>
        <span class="cursor"></span>
      </div>
      <div class="diaryStamp">
        <v-progress-circular
          v-if="stampLoading"
          class="mx-auto"
          style="display: block"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <div v-else>
          <div class="diaryStampList">
            <div
              v-for="stamp in stampList"
              :key="'stamp-' + stamp.id"
              class="stamp"
              cols="4"
            >
              <v-img
                :src="stamp.image"
                aspect-ratio="1"
                :class="{'checked': checkedStamp == stamp.id}"
                @click="selectStamp(stamp.id)"
                style="border: 1px solid transparent;"
              >
                <v-icon 
                  v-if="checkedStamp == stamp.id"
                  class="stampCheck"
                >mdi-check</v-icon>
              </v-img>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="customButtonBox2"
      v-show="!loading"
    >
      <div class="customButton2 gray" @click="save(false)">재도전</div>
      <div class="customButton2" @click="save(true)">승인</div>
    </div>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    reviewValid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notifications: false,
      sound: true,
      widgets: false,
      stampLoading: true,
      stampList: undefined,
      checkedStamp: undefined,
      comment: undefined,
      alert: false,
      alertMessage: undefined,
      loading: true
    };
  },
  methods: {
    getStamp() {
      // this.$axios.get("/challenges/stamps").then((response) => {
      //   this.stampList = response.data;
      //   this.stampLoading = false;
      //   this.loading = false;
      // });
      this.stampList = [
        {
          id: 1,
          image: require("@/assets/images/diary/stamp.png"),
        },
        {
          id: 2,
          image: require("@/assets/images/diary/stamp.png"),
        },
        {
          id: 3,
          image: require("@/assets/images/diary/stamp.png"),
        },
      ];
      this.stampLoading = false;
      this.loading = false;
    },
    selectStamp(i) {
      if (this.checkedStamp == i) {
        this.checkedStamp = undefined;
      } else {
        this.checkedStamp = i;
      }
    },
    save(passed){
      this.loading = true;
      if(this.checkedStamp == undefined || !this.checkedStamp){
        this.alert = true;
        this.alertMessage = '도장을 선택해주세요.';
        this.loading = false;
        return false;
      } else if(!this.comment || !this.comment == undefined){
        this.alert = true;
        this.alertMessage = '코멘트를 입력해주세요.';
        this.loading = false;
        return false;
      }else{
        this.alert = false;
        // this.$emit('save',passed, this.checkedStamp, this.comment);
        this.loading = false;
        this.$router.push("/calendar");
      }
    },
  },
  mounted() {
    this.getStamp();
  },
};
</script>

<style scoped lang="scss">
.checked {
    border: 1px solid red !important;
}
.diaryCheck{
  margin: 0 -20px;
}
.diaryCheckTitle{
  width: 100%;
  height: 56px;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  background-color: #FFB5CC;
  box-shadow: 0 2px 3px rgba(0,0,0,.2);
}
.diaryCheckContents{
  width: 100%;
  height: calc(100% - 120px);
  background-color: #fff;
  overflow-y: scroll;
  padding-bottom: 50px;

  .diaryCheckText{
    position: relative;

    &.v-text-field{
      padding: 0;
      margin: 0;

      input{
        padding: 0;
      }
    }
    .cursor{
      height: 32px;
      position: absolute;
      top: 20px;
      left: 20px;
      border-right: 1px solid #000;
      animation: cursor 500ms step-end infinite alternate;
      
      @keyframes cursor {
        from, to{
          opacity: 0;
        }
        50%{
          opacity: 1;
        }
      }
    }
  }
  .diaryStamp{
    .diaryStampList{
      padding: 4px;
      display: flex;
      flex-flow: wrap;

      .stamp{
        width: 33.3333%;
        padding: 4px;

        .stampCheck{
          width: 20px;
          height: 20px;
          margin-top: 2px;
          margin-left: 4px;
          border-radius: 100%;
          color: #fff;
          font-size: 18px;
          background-color: #ce0c0c;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.diaryCheckContents{
  .diaryCheckText{
    .v-text-field{
      padding: 0;
      margin: 0;

      &.v-input--is-focused{
        &+.cursor{
          display: none;
        }
      }
      .v-text-field__slot{
        padding: 20px;
        background-color: #f2f2f2;

        input{
          font-size: 28px;
          font-family: 'Hardworking';

          &::placeholder{
            color: #555;
          }
        }
      }
    }
    .v-text-field > .v-input__control > .v-input__slot:before{
      border-color: #ccc;
    }
    
  }
}
</style>